<template>

  <div>

    <div class="ui large breadcrumb">
      <div class="bold section">{{ title }}</div>
    </div>

    <bookmark-button :label="title" />

    <div class="ui divider"></div>

    <div class="ui grid">      
      <div class="eleven wide computer sixteen wide tablet sixteen wide mobile column">
        <button class="ui blue button" @click="$router.push('/admin/notes/new')">
          <i class="plus icon"></i> Novo Recado
        </button>
      </div>
      <div class="five wide computer sixteen wide tablet sixteen wide mobile column">
        <div class="ui basic right aligned segment no-padding no-margin">
          <div class="ui form">
            <div class="field">
              <search-input id="notes-search-input" ref="searchInput" @onSearch="search" />
            </div>
          </div>    
        </div> 
      </div>
    </div>

    <data-table id="notes-dtbl" ref="dtbl" sortBy="createdAt" :asc="false" :service="service" :attributes="attributes" 
      :fields="fields" @onRowClick="navToNoteForm" />

  </div>

</template>

<script>
  
  import NoteService from "@/services/note-service"
  import { gridPage, onlySimavet } from "@/mixins"

  export default {    

    name: "NotesPage",

    mixins: [gridPage, onlySimavet],

    data() {
      return {        
        title: "Recados",
        service: new NoteService(),
        attributes: ["id", "subject", "severity", "createdAt"],
        fields: [                    
          { prop: "createdAt", label: "Data Criação", render: this.renderDate },
          { prop: "severity", label: "Tipo", render: this.renderType },          
          { prop: "subject", label: "Assunto" },
        ],
      }
    },

    methods: {

      renderType(note) {

        const types = {
          urgent: { icon: "exclamation circle red icon", label: "Urgente" },
          warning: { icon: "exclamation triangle orange icon", label: "Alerta" },
          info: { icon: "info circle blue icon", label: "Informativo" },
        }

        return `<i class="${types[note.severity].icon}"></i> ${types[note.severity].label}`
      },

      renderDate(note) {
        return this.$formatDate(note.createdAt)
      },

      navToNoteForm(data) {
        this.$router.push("/admin/notes/" + data.row.id)
      },
    },
  }

</script>